import { useState } from 'react';

type PreviewMode = 'light' | 'dark' | 'checker';

interface ArtworkPreviewProps {
  src: string;
  alt?: string;
  maxHeight?: number;
}

export function ArtworkPreview({ src, alt = 'Artwork preview', maxHeight = 400 }: ArtworkPreviewProps) {
  const [mode, setMode] = useState<PreviewMode>('dark');

  const canvasClass = `preview-canvas preview-canvas--${mode}`;

  return (
    <div>
      <div className="preview-toolbar">
        <span style={{ fontSize: '0.78rem', color: 'var(--ink-muted)', marginRight: '6px' }}>Background:</span>
        <button
          className={`preview-mode-btn ${mode === 'light' ? 'preview-mode-btn--active' : ''}`}
          onClick={() => setMode('light')}
          type="button"
        >
          Light
        </button>
        <button
          className={`preview-mode-btn ${mode === 'dark' ? 'preview-mode-btn--active' : ''}`}
          onClick={() => setMode('dark')}
          type="button"
        >
          Dark
        </button>
        <button
          className={`preview-mode-btn ${mode === 'checker' ? 'preview-mode-btn--active' : ''}`}
          onClick={() => setMode('checker')}
          type="button"
        >
          Checker
        </button>
      </div>
      <div className={canvasClass} style={{ maxHeight }}>
        <img src={src} alt={alt} style={{ maxHeight, maxWidth: '100%' }} />
      </div>
    </div>
  );
}
